import script from "./indexpage.vue?vue&type=script&setup=true&lang=js"
export * from "./indexpage.vue?vue&type=script&setup=true&lang=js"

import "./indexpage.vue?vue&type=style&index=0&id=63f89666&lang=css"

const __exports__ = script;

export default __exports__